import React, { useState, useEffect, Suspense } from "react";
import PropTypes from "prop-types";
import StartFromScratch from "./StartFromScratch";
import MyTemplatesScreen from "./MyTemplatesScreen";
import ViewAllFormatTemplates from "./ViewAllFormatTemplates";
import ViewAllTemplates from "./ViewAllTemplates";
import { connect } from "react-redux";
import TldrTrialEndedModal from "../TldrSettings/TldrBillingAndPayments/Modals/TldrTrialEndedModal";
import AutoGeneration from "../TldrAi/AutoGeneration";
import TldrPaymentStatusModal from "../TldrSettings/TldrBillingAndPayments/Modals/TldrPaymentStatusModal";
import { BILLING_AND_PAYMENT, BILLING_PLANS } from "../_utils/routes";
import { useHistory, useLocation } from "react-router-dom";
import {
  SAVED_ELEMENTS_PANEL,
  SAVED_TEMPLATES_PANEL,
} from "../_components/details/constants";
import { resetCardsSelection } from "../_actions/folderActions";
import { Box } from "@chakra-ui/react";
import AiShortFormPanel from "../TldrAi/AiShortFormPanel";

const CalendarPlanner = React.lazy(() =>
  import("./../TldrCalendarPlanner/CalendarPlanner")
);
const Planner = React.lazy(() => import("./../TldrCalendarPlanner/Planner"));
const Analytics = React.lazy(() => import("../_containers/Analytics/Analytics"));
const MyDesigns = React.lazy(() => import("./MyDesigns"));
const QuickStart = React.lazy(() => import("./QuickStart"));
const MyAssets = React.lazy(() => import("./MyAssets"));
const MyFolders = React.lazy(() => import("./MyFolders"));
const AIPlayground = React.lazy(() => import("../TldrAi/AIPlayground"));
const Post = React.lazy(() => import("../TldrCalendarPlanner/Post"));
const Draft = React.lazy(() => import("../TldrCalendarPlanner/Draft"));
const FolderContentsView = React.lazy(() =>
  import("../_components/home/FolderContentsView")
);
const TemplatesMasonryView = React.lazy(() => import("./TemplatesMasonryView"));

const PanelContainer = ({ children, mt }) => {
  return (
    <Box mt={mt ? mt : ""} p={"0"}>
      <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
    </Box>
  );
};

const Marketplace = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [selectedTab] = useState(props.path);
  const [showTrialPeriodEndedModal, setShowTrialPeriodEndedModal] =
    useState(false);
  const [showPaymentStatusModal, setShowPaymentStatusModal] = useState({
    state: false,
    status: "",
    type: null,
    error: null,
  });
  const [userDetail, setUserDetail] = useState(props.authUser);

  useEffect(() => {
    let plan = props.subscription.subscribedPlan;
    if (plan?.trial_remaining_days < 0) {
      setShowTrialPeriodEndedModal(true);
    } else if (
      plan?.trial_remaining_days == null &&
      plan.hasOwnProperty("status") &&
      plan.status !== "active"
    ) {
      setShowPaymentStatusModal({
        state: true,
        status: "error",
        type: null,
        error: null,
      });
    } else {
      setShowTrialPeriodEndedModal(false);
    }
  }, [props.subscription.subscribedPlan]);

  useEffect(() => {
    setUserDetail(props.authUser);
  }, [props.authUser]);

  useEffect(() => {
    if (props.selectedCards.length > 0) {
      props.resetCardsSelection();
    }
  }, []);

  return (
    <Box
      w={"100%"}
      overflowY={
        props.isMobileView &&
        selectedTab !== "publishing" &&
        selectedTab !== "planner"
          ? "auto"
          : ""
      }
    >
      <Box id="marketplace" color={"gray.100"}>
        <Box maxW={"100%"}>
          {selectedTab === "projects" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyDesigns renderlocation="projects"/>
            </PanelContainer>
          ) : selectedTab === "my_projects" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyDesigns renderlocation="projects" creatorId={userDetail.pk} />
            </PanelContainer>
          ) : selectedTab === "shared_with_me_projects" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyDesigns renderlocation="projects" excludeCreatorId={userDetail.pk} />
            </PanelContainer>
          ) : selectedTab === "quick_start" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <QuickStart />
            </PanelContainer>
          ) : selectedTab === "assets" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyAssets />
            </PanelContainer>
          ) : selectedTab === "team_templates" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyTemplatesScreen panelType={SAVED_TEMPLATES_PANEL} />
            </PanelContainer>
          ) : selectedTab === "my_templates" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyTemplatesScreen
                panelType={SAVED_TEMPLATES_PANEL}
                creatorId={userDetail.pk}
              />
            </PanelContainer>
          ) : selectedTab === "shared_with_me_templates" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyTemplatesScreen
                panelType={SAVED_TEMPLATES_PANEL}
                excludeCreatorId={userDetail.pk}
              />
            </PanelContainer>
          ) : selectedTab === "my_components" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyTemplatesScreen panelType={SAVED_ELEMENTS_PANEL} />
            </PanelContainer>
          ) : selectedTab === "search_templates" ? (
            <PanelContainer mt={["unset", "unset", "1.5rem", "1.5rem"]}>
              <TemplatesMasonryView />
            </PanelContainer>
          ) : selectedTab === "templates_screen" ? (
            <PanelContainer mt={["unset", "unset", "1.5rem", "1.5rem"]}>
              <ViewAllFormatTemplates />
            </PanelContainer>
          ) : selectedTab === "templates_by_format" ? (
            <PanelContainer mt={["unset", "unset", "1.5rem", "1.5rem"]}>
              <ViewAllTemplates />
            </PanelContainer>
          ) : selectedTab === "layouts" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <StartFromScratch />
            </PanelContainer>
          ) : selectedTab === "my_folders" ? (
            <PanelContainer mt={["unset", "unset", "unset", "1.5rem"]}>
              <MyFolders />
            </PanelContainer>
          ) : selectedTab === "ai" ? (
            <PanelContainer>
              <AIPlayground tab={location?.state?.tab || "welcome"} />
            </PanelContainer>
          ) : selectedTab === "documents" ? (
            <PanelContainer>
              <AIPlayground />
            </PanelContainer>
          ) : selectedTab === "my_documents" ? (
            <PanelContainer>
              <AIPlayground />
            </PanelContainer>
          ) : selectedTab === "shared_with_me_documents" ? (
            <PanelContainer>
              <AIPlayground />
            </PanelContainer>
          ) : selectedTab === "favorites" ? (
            <PanelContainer>
              <AIPlayground />
            </PanelContainer>
          ) : selectedTab === "ai_new" ? (
            <PanelContainer>
              <AutoGeneration />
            </PanelContainer>
          ) : selectedTab === "publishing" ? (
            <PanelContainer>
              <CalendarPlanner />
            </PanelContainer>
          ) : selectedTab === "planner" ? (
            <PanelContainer>
              <Planner />
            </PanelContainer>
          ) : selectedTab === "analytics" ? (
            <PanelContainer>
              <Analytics />
            </PanelContainer>
          ) : selectedTab === "post" ? (
            <PanelContainer>
              <Post />
            </PanelContainer>
          ) : selectedTab === "draft" ? (
            <PanelContainer>
              <Draft />
            </PanelContainer>
          ) : selectedTab === "search_templates" ? (
            <PanelContainer>
              <AutoGeneration />
            </PanelContainer>
          ) : selectedTab === "folder_contents" ? (
            <PanelContainer>
              <FolderContentsView />
            </PanelContainer>
          ) 
          : selectedTab === "ai_input_form" ? (
            <PanelContainer>
              <AIPlayground tab="info" />
            </PanelContainer>
          )
          : selectedTab === "ai_short_form_panel" ? (
            <PanelContainer>
             <AiShortFormPanel/>
            </PanelContainer>
          ) 
          : (
            <></>
          )}
        </Box>
      </Box>
      {showTrialPeriodEndedModal && (
        <div onClick={(e) => e.stopPropagation()}>
          <TldrTrialEndedModal
            showFeatures
            show={showTrialPeriodEndedModal}
            onHide={() => {
              setShowTrialPeriodEndedModal(false);
              history.push(BILLING_PLANS);
            }}
          />
        </div>
      )}
      <TldrPaymentStatusModal
        show={showPaymentStatusModal.state}
        status={showPaymentStatusModal.status}
        type={showPaymentStatusModal.type}
        onHide={() => {
          setShowPaymentStatusModal({
            state: false,
            status: "",
            type: null,
            error: null,
          });
          history.push(BILLING_AND_PAYMENT);
        }}
      />
    </Box>
  );
};

Marketplace.propTypes = {
  path: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  subscription: state.subscription,
  authUser: state.auth?.payload?.user,
  isMobileView: state.app.isMobileView,
  selectedCards: state.folders.selectedCards,
});

const mapDispatchToProps = (dispatch) => ({
  resetCardsSelection: () => dispatch(resetCardsSelection()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Marketplace);
